import { useEffect } from 'react';
import { useOrderAssistLegacyState } from '../../../../../../vim-os-sdk-migration/ehr-state';
import { OrderAssistEventHandlers } from './types';

export const useVimOsSdkEventHandlers = ({
  onPatientInContextEvent,
  onPatientOutOfContextEvent,
  onOrderViewedEvent,
  onOrderClosedEvent,
  onReferralViewedEvent,
  onReferralClosedEvent,
}: OrderAssistEventHandlers) => {
  const { patient, referral, orders } = useOrderAssistLegacyState();

  useEffect(() => {
    if (patient) {
      onPatientInContextEvent(patient);
    } else {
      onPatientOutOfContextEvent();
    }
  }, [patient, onPatientInContextEvent, onPatientOutOfContextEvent]);

  useEffect(() => {
    if (referral && referral.patient) {
      onReferralViewedEvent(referral);
    } else if (!referral && !orders) {
      // Only fire referralClosed if we're NOT in an order context
      onReferralClosedEvent();
    }
  }, [referral, orders, onReferralViewedEvent, onReferralClosedEvent]);

  useEffect(() => {
    if (!orders) {
      onOrderClosedEvent();
      return;
    }

    const { selectedOrders, patient } = orders;
    // Mirror the referral pattern: check for valid order first, only fire closed event if truly closed

    if (selectedOrders?.length === 1 && patient) {
      onOrderViewedEvent({
        order: selectedOrders[0],
        patient,
      });
    }
  }, [orders, onOrderViewedEvent, onOrderClosedEvent]);
};
